import type { UserLocaleCode } from './user-locale';
import phpLangidConfig from './php-langid-config.json';

export type PhpLangid = keyof typeof phpLangidConfig;

/**
 * Default user locale for each Carpenter language subdomain.
 * Used as fallback for first-time visitors who have no cookie yet.
 */
export const defaultUserLocaleByPhpLangid = Object.fromEntries(
   Object.entries(phpLangidConfig).map(([langid, { defaultUserLocale }]) => [
      langid,
      defaultUserLocale,
   ])
) as Record<PhpLangid, UserLocaleCode>;

/**
 * PHP language code mapping. PHP uses "jp" for Japanese while
 * we use the standard "ja" code everywhere else.
 */
const PHP_LANGUAGE_CODE: Record<string, string> = {
   ja: 'jp',
};

export function toPhpLangId(languageCode: string): string {
   return PHP_LANGUAGE_CODE[languageCode] ?? languageCode;
}

const STANDARD_LANGUAGE_CODE: Record<string, string> = Object.fromEntries(
   Object.entries(PHP_LANGUAGE_CODE).map(([standard, php]) => [php, standard])
);

export function fromPhpLangId(phpLangId: string): string {
   // Own-key check: view-langid cookie values reach this; `?? ` alone would
   // return inherited members like Object.prototype.toString for hostile keys.
   return Object.prototype.hasOwnProperty.call(STANDARD_LANGUAGE_CODE, phpLangId)
      ? STANDARD_LANGUAGE_CODE[phpLangId]
      : phpLangId;
}
